import {createSelector} from '@reduxjs/toolkit';

export const getSelectedItemTypes = state => state.itemTypes.selected;

export const getOnlySkySat = createSelector(getSelectedItemTypes, itemTypes =>
  Object.keys(itemTypes).every(type => type.indexOf('SkySat') >= 0),
);
